import React from 'react';
import { useState,useEffect } from 'react';
import quranBackdrop from '../../assets/images/quranBackdrop.svg';
import '../quran/HolyQuranStyle.scss';
// import playIcon from '../../assets/icons/play.svg';
import { useNavigate,Link,useParams } from "react-router-dom";
import './Mafatih.scss'
import Col from 'react-bootstrap/Col';
import axiosServise from '../ApiService'
import BackComponent from "../BackComponent/BackComponent.tsx";
 function Mafatih() {
  const [mafatihValue, setmafatihValue] = useState([]);
  const [mafatihData, setmafatihData] = useState([]);
  const [mafatihPartName, setMafatihPartName] = useState([]);
  const nav = useNavigate();
  
  useEffect(() => {
    getMafateehList()
      
  }, [setmafatihValue]) 



//برای دریافت لیست  از روی سلکت کاربر
const getMafateehList=(item)=>{
  if(window.location.pathname.indexOf(item)){
    setMafatihPartName(item)
  }

  axiosServise.get(`PrayerCategories`).then(response => {
    const data = response.data.content;
    setmafatihValue(data);
    setmafatihData(data)
    localStorage.setItem("PrayerCategories", JSON.stringify(data));
}).catch(error => {

});
}


const goToMafateehPage=(id)=>{
  nav(`/Mafatih/content/${id}`)
}



const search=(serachValue)=>{
  if(serachValue==null){
    setmafatihValue(mafatihData)
  }else{
    let data=[]
    mafatihData.forEach(item => {
      if (item.name.indexOf(serachValue) > -1) {
        data.push(item)
      }
    });
    setmafatihValue(data)
  }
}

  return (
    
    <div className='Holy-QuranPage pt-4'>
        <BackComponent/>
        <div className='body-secondPage mafatih-listPage d-flex align-items-center pt-3'>
        <div className='col-12 col-md-7 m-auto mt-md-2 mt-2 mb-md-6'>
        <div className='nameOfSure col-11 col-md-9 mt-md-5 mt-5 m-auto'>
            <div>
            <img src={quranBackdrop} alt="" />
            </div>
            <div className='searchBox col-9 col-md-6'>
                <div><span>ادعیه مورد نظر خود را وارد نمایید </span></div>
                <div className='searchInput-box'><input type="text" className='searchText' onChange={event=>{search(event.target.value)}} /></div>
              </div>
          </div>
          </div>

        {/* <div className='col-12 col-md-7 m-auto mt-md-2 mt-2 mb-md-6 d-flex flex-column align-items-center'>
          <div className='mafatih-list-button-container col-9 d-flex justify-content-evenly'>

<Link to='/Mafatih/dua' onClick={()=>{getMafateehList('dua')}} ><button className='mafatih-list-button p-1' >دعاها</button></Link>
<Link to='/Mafatih/amal' onClick={()=>{getMafateehList('amal')}}><button className='mafatih-list-button p-1'>اعمال</button></Link>
<Link to='/Mafatih/ziarat' onClick={()=>{getMafateehList('ziarat')}}><button className='mafatih-list-button p-1'>زیارت</button></Link>
<Link to='/Mafatih/molhaghat' onClick={()=>{getMafateehList('molhaghat')}}><button className='mafatih-list-button p-1'>ملحقات</button></Link>
</div>

<div>
  <input type="text" className='mafatih-list-search'/>
</div>
        </div> */}

            <div className='quran-container col-11 col-md-9'> 
              <div className='surah'>
                    <div className='container-holypage'>

                    {mafatihValue.length === 0 &&
<Col xs={12} md={12}>
<div className='notFind-Surah'>
<span>ادعیه مورد نظر یافت نشد.</span>
</div>
</Col>
                        }

                      {
                        mafatihValue.map((item,index) => 
                        <div onClick={()=>{goToMafateehPage(`${item.code}`)}} key={item.code} className='surah-container'>
                          <div className='surah-boxStyle col-10 col-md-11'>
                             <div className='surah-number col-2'>
                              
                              <span className='p-1 p-md-0'>{index+1}</span>
                              </div> 
                              <span className='surah-name col-11' id={index+1}>{item.name}</span>
                              </div>

                               {/* <div className='playIconQuran-style col-1 col-md-1'><img className='col-5' src={playIcon} alt="" /></div> */}
                               </div>
                               )
                      }
                      
                    </div>
              </div>
            </div> 
        </div>
             <div>

            </div>
  </div>
  )
}
export default Mafatih;